<template>
  <div class="index2025final">
    <div class="area" >  
        <ul class="circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <img src="../../../assets/images/DevBg.svg" height="80%" style="position:absolute; right:50px; bottom:70px;"/>
    </div >
    
    <div class="context">
      <div class="title">
        <div class="title-logo">
            <img src="../../../assets/images/ICodeChina.png"/>
          <div class="typing-slider">
            <p>CODING FOR EVERYONE!</p>
          </div>
        </div>
        
        <!-- 比赛主标题 -->
        <h1>第七届ICode国际青少年编程竞赛<br/>中国区决赛</h1>
        <!-- 比赛副标题 -->
        <h2>比赛时间：<br/>第一场：2025年7月12日-7月13日<br/>第二场：2025年8月02日-8月03日</h2>
      </div>

      <!-- 报名和参赛按钮 -->
      <div class="btnlist">
        <div class="bigbutton" @click="toLogin()">
            登录
        </div>
        <!-- <div class="bigbutton" @click="toLogin('2025_hk')">
            香港
        </div> -->
      </div>

      <!-- 支持单位信息 -->
      <div class="list">
        <ul>
          <li v-for="item in pageText.orgList" :key="item.name">
            {{item}}
          </li>
        </ul>
      </div>
    </div>
    
  </div>
</template>
<script>
import {
    eventInfo
}
from "./eventConfig";

export default {
    data() {
        return {
            pageText: eventInfo().pageText,
            channel: eventInfo().channel,
        };
    },
    methods: {
        toLogin(channel) {
            channel = channel ? channel : this.channel;
            this.$router.push({
                path: "/" + channel + "/login",
            });
        },
        toSignup() {
            this.$router.push({
                path: "/" + this.channel + "/signup",
            });
        },
        async checkServerTime() {
            try {
                await this.$http
                .getAxios(`foo/getTime`, {
                    method: "get",
                })
                .then((res) => {

                    if (res.status == 200) {
                    let timeGap = Math.abs(new Date().getTime() / 1000 - res.data);
                    if(timeGap > 300){ // 5分钟以上提示
                        this.$notify.error({
                        title: this.$t("时间差异过大"),
                        message: "你的本地时间和服务器时间差距较大，请检查一下您的电脑本地时间。"
                        });      
                    }

                    } else {
                    this.$notify.error({
                        title: this.$t("无法连接到服务器"),
                        message: "无法连接到服务器，请确认您的网络正常",
                    });
                    }
                });
            } catch (e) {
                console.log(e);
            }
        },
    }
};
</script>

<style lang="scss">
$slider-name: typing-slider;
$slides: 3;
$typing-duration: 2s;
$tab-letters: 20; //number of characters in each paragraph
$slider-font-size: 3rem;
$background: #4e54c8;
.index2025final {
    * {
        margin: 0px;
        padding: 0px;
    }
    // body{
    //   // font-family: Consolas, monospace;
    // }
    @keyframes cursor {
        from,
        to {
            border-color: transparent;
        }
        50% {
            border-color: black;
        }
    }
    @keyframes typing {
        from {
            width: 100%;
        }
        90%,
        to {
            width: 0;
        }
    }
    @keyframes slide {
        #{100% / $slides} {
            font-size: $slider-font-size;
            letter-spacing: 3px;
        }
        to {
            font-size: 0;
            letter-spacing: 0;
        }
    }
    .#{$slider-name} {
        font-family: Consolas, monospace;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
    }
    .#{$slider-name} p {
        position: relative;
        display: inline;
        font-size: 0;
        text-transform: uppercase;
        letter-spacing: 0;
        animation: slide $typing-duration * $slides step-start infinite;
    }
    .#{$slider-name} p::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        border-left: 3px solid black;
        background-color: $background;
        animation: typing $typing-duration infinite, cursor 1s infinite;
    }
    @each $letters in $tab-letters {
        $i: index($tab-letters, $letters);
        .#{$slider-name} p:nth-child(#{$i}) {
            animation-delay: $typing-duration * ($i - 1);
            &::after {
                animation-delay: $typing-duration * ($i - 1);
                animation-timing-function: steps(#{$letters}),
                step-end;
            }
        }
    }
    .context {
        width: 100%;
        position: absolute;
        .title {
            margin-top: 3rem;
            text-align: left;
            font-size: 5rem;
            text-shadow: 0px 2px 5px #333;
            user-select: none;
            touch-action: none;
            .title-logo {
                text-align: left;
                margin-left: 70px;
                color: #fff;
                font-size: 2.2rem;
                height: 60px;
                display: flex;
                justify-content: start;
                img {
                    height: 90%;
                }
                .typing-slider {
                    margin-left: 20px;
                }
            }
            h1 {
                text-align: left;
                margin-left: 70px;
                // letter-spacing: 2px;
                color: #fff;
                font-size: 3.6rem;
            }
            h2 {
                margin-top: 2rem;
                margin-left: 70px;
                color: #fff;
                font-size: 2.0rem;
            }
        }
        .btnlist {
            margin-left: 70px;
            display: flex;

            .bigbutton {
                background: orange;
                border-radius: 8px;
                border: #fff;

                margin: 20px 32px;
                padding: 16px 48px;

                font-size: x-large;
                box-shadow: 3px 3px 2px 2px gray;
            }
            .bigbutton:hover {
                background: #f56c6c;
                translate: 1px 1px;
            }
        }
        .list {
            margin-top: 3rem;
            margin-left: 70px;
            padding-top: 1rem;
            padding-bottom: 3.5rem;
            box-sizing: border-box;
            color: #fff;
            text-shadow: 0px 2px 5px #333;
            ul {
                list-style-type: none;
                li {
                    font-size: 18px;
                    line-height: 1.6rem;
                }
            }
        }
    }
    .context h1 {
        text-align: center;
        color: #fff;
        font-size: 50px;
    }
    .area {
        background: #4e54c8;
        width: 100%;
        height: 100vh;
    }
    .circles {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .circles li {
        position: absolute;
        display: block;
        list-style: none;
        width: 20px;
        height: 20px;
        background: rgba(255, 255, 255, 0.2);
        animation: animate 25s linear infinite;
        bottom: -150px;
    }
    .circles li:nth-child(1) {
        left: 25%;
        width: 80px;
        height: 80px;
        animation-delay: 0s;
    }
    .circles li:nth-child(2) {
        left: 10%;
        width: 20px;
        height: 20px;
        animation-delay: 2s;
        animation-duration: 12s;
    }
    .circles li:nth-child(3) {
        left: 70%;
        width: 20px;
        height: 20px;
        animation-delay: 4s;
    }
    .circles li:nth-child(4) {
        left: 40%;
        width: 60px;
        height: 60px;
        animation-delay: 0s;
        animation-duration: 18s;
    }
    .circles li:nth-child(5) {
        left: 65%;
        width: 20px;
        height: 20px;
        animation-delay: 0s;
    }
    .circles li:nth-child(6) {
        left: 75%;
        width: 110px;
        height: 110px;
        animation-delay: 3s;
    }
    .circles li:nth-child(7) {
        left: 35%;
        width: 150px;
        height: 150px;
        animation-delay: 7s;
    }
    .circles li:nth-child(8) {
        left: 50%;
        width: 25px;
        height: 25px;
        animation-delay: 15s;
        animation-duration: 45s;
    }
    .circles li:nth-child(9) {
        left: 20%;
        width: 15px;
        height: 15px;
        animation-delay: 2s;
        animation-duration: 35s;
    }
    .circles li:nth-child(10) {
        left: 85%;
        width: 150px;
        height: 150px;
        animation-delay: 0s;
        animation-duration: 11s;
    }
    @keyframes animate {
        0% {
            transform: translateY(0) rotate(0deg);
            opacity: 1;
            border-radius: 0;
        }
        100% {
            transform: translateY(-1000px) rotate(720deg);
            opacity: 0;
            border-radius: 50%;
        }
    }
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 50px);
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/contest/2025_final/compete-Pre.vue